import {useEffect} from "react";
import SignInPage from "./SignInPage";
import {FluentProvider, makeStyles, Spinner, Theme, webDarkTheme, webLightTheme} from "@fluentui/react-components";
import Navigation from "./Navigation";
import {useError, useStatePair, useUndefined} from "../../type/States";
import {AdminSessionValueObject} from "../../model/vo/admin/AdminSessionValueObject";
import {AdminValueObject} from "../../model/vo/admin/AdminValueObject";
import {AdminSessionIO} from "../../io/admin/AdminSessionIO";
import {AdminIO} from "../../io/admin/AdminIO";
import {useAdminId} from "../../stores/useAdminId";

const useStyles = makeStyles({
    provider: {
        display: 'inline-block',
        minWidth: '100vw'
    },
    root: {
        display: 'inline-block',
        minHeight: '100vh',
    }
})

function getThemeFromStorage(): Theme {
    if (localStorage.getItem('isDark') === 'true') {
        return webDarkTheme
    } else  {
        return webLightTheme
    }
}

function setThemeIntoStorage(theme: Theme) {
    if (theme === webDarkTheme) {
        localStorage.setItem('isDark', 'true');
    } else {
        localStorage.removeItem('isDark');
    }
}

export default function AdminRouter() {
    const styles = useStyles()
    const themeState = useStatePair<Theme>(getThemeFromStorage())
    const adminSessionState = useUndefined<AdminSessionValueObject>()
    const adminSessionErrorState = useError()
    const adminState = useUndefined<AdminValueObject>()
    const adminErrorState = useError()
    const { setAdminId } = useAdminId()


    useEffect(() => {
        setThemeIntoStorage(themeState.value)
    }, [themeState.value]);

    useEffect(() => {
        if (adminSessionState.value !== undefined) {
            return
        }

        AdminSessionIO.getCurrent()
            .then(adminSessionState.setDefinedValue)
            .catch(adminSessionErrorState.setValue)

    }, [adminSessionState.value]);

    useEffect(() => {
        if (adminSessionState.value === undefined) {
            return
        }
        if (adminSessionState.value.adminId === null) {
            return
        }
        if (adminState.value !== undefined) {
            return
        }

        AdminIO.get(adminSessionState.value.adminId)
            .then(adminState.setDefinedValue)
            .catch(adminErrorState.setValue)

        setAdminId(adminSessionState.value.adminId)

    }, [adminSessionState.value, adminState.value]);

    function Page() {
        if (adminSessionState.value === undefined) {
            return <Spinner />
        }

        if (adminSessionState.value.adminId === null) {
            return <SignInPage themeState={themeState} />
        }

        if (adminState.value === undefined) {
            return <Spinner />
        }

        return <>
            <Navigation
                themeState={themeState}
                adminSession={adminSessionState.value}
                admin={adminState.value} />
        </>
    }

    return <>
        <FluentProvider theme={themeState.value} className={styles.provider}>
            <div className={styles.root}>
                <adminSessionErrorState.Dialog
                    themeState={themeState} />
                <adminErrorState.Dialog
                    themeState={themeState} />
                <Page />
            </div>
        </FluentProvider>
    </>
}